import { line, curveMonotoneX, area } from 'd3-shape';
import {
  scaleTime,
  scaleLinear,
  scaleBand,
  scaleSqrt,
  scaleSequential,
} from 'd3-scale';
import { axisBottom, axisLeft, axisRight } from 'd3-axis';
import { timeParse, timeFormat } from 'd3-time-format';
import { timeDays } from 'd3-time';
import { select } from 'd3-selection';
import { extent, max, min } from 'd3-array';
import { geoNaturalEarth1, geoPath, geoArea } from 'd3-geo';
import { interpolateRdYlGn } from 'd3-scale-chromatic';
/* import { csvParse } from "d3-dsv"; */

export default {
  line,
  area,
  curveMonotoneX,
  scaleTime,
  scaleLinear,
  scaleBand,
  scaleSqrt,
  scaleSequential,
  axisBottom,
  axisLeft,
  axisRight,
  timeParse,
  timeFormat,
  timeDays,
  select,
  extent,
  min,
  max,
  geoNaturalEarth1,
  geoPath,
  geoArea,
  interpolateRdYlGn,
};

// use
// import d3 from './d3Importer.js';
